import React, { Component } from "react";
import withNavigate from '../../components/withNavigate'
import { Form } from 'react-bootstrap';
import UserService from "../../services/api/user";
import toast from "react-hot-toast";
import { getYear } from "../../settings/shared/commonMethods";
import { APP_VERSION } from "../../settings/shared/constants";


class UpdatePassword extends Component {
    constructor(props) {
        super(props);
        this.state = {
            height: window.innerHeight,
            oldPassword: '',
            newPassword: '',
            confirmPassword: "",
            errorMessage: "",
            showOldPassword: false,
            showNewPassword: false,
            showConfirmPassword: false,
        }
    }

    moveToLogin = () => {
        localStorage.clear();
        sessionStorage.clear();
        this.props.navigate("/auth/login");
    }

    togglePasswordVisibility = (field) => {
        this.setState((prevState) => ({ [field]: !prevState[field] }));
    };

    handleChange = (event) => {
        event.preventDefault();
        const { name, value } = event.target;
        this.setState({ [name]: value });
    }
    // signin button click event
    handleSubmit = (event) => {
        event.preventDefault();
        if ((this.state.oldPassword === "" || this.state.oldPassword === undefined) &&
            (this.state.newPassword === "" || this.state.newPassword === undefined) &&
            (this.state.confirmPassword === "" || this.state.confirmPassword === undefined)) {
            this.setErrorMessage("Please enter all require fields");
        }
        else if (this.state.oldPassword === "" || this.state.oldPassword === undefined) {
            this.setErrorMessage("Please enter Old Password");
        }
        else if (this.state.newPassword === "" || this.state.newPassword === undefined) {
            this.setErrorMessage("Please enter New Password");
        }
        else if (this.state.confirmPassword === "" || this.state.confirmPassword === undefined) {
            this.setErrorMessage("Please enter Confirm Password");
        }
        else if (this.state.newPassword !== this.state.confirmPassword) {
            this.setErrorMessage("Password and confirm password does not match");
        }
        else {
            this.setErrorMessage("")
            let postData = {
                oldPassword: this.state.oldPassword,
                newPassword: this.state.newPassword
            }
            UserService.updatePassword(postData)
                .then((response) => {
                    if (response.status === 'SUCCESS') {
                        localStorage.clear();
                        toast.success("Password Updated Successfully!");
                        this.moveToLogin()
                    } else {
                        toast.error(response.errorMessage);
                    }
                });
        }
    }

    setErrorMessage = (message) => {
        this.setState({
            errorMessage: message
        })
    }

    render() {
        return (<>
            <div>
                <div className="log-top-circle"></div>
                <div className="log-bottom-circle"></div>
                <div className="log-bottom2-circle"></div>

                <div className="auth-footer">
                    <span style={{ color: '#64748b', fontSize: '13px', fontWeight: '400' }}>
                        © {getYear()} SuperAgentX • Version {APP_VERSION}
                    </span>
                </div>
            </div>
            <div className="card-log">
                <div className="card p-5 card-log-main">
                    {this.state.errorMessage && <div className='bg-error-red mb-2'>
                        <span className='txt-white font12'>{this.state.errorMessage}</span>
                    </div>}
                    <div className="d-flex flex-column">
                        <span className="font-bold font32 mb-2">Update Password</span>
                        <span className="font-regular font12 txt-grey">You need to update your password because this is the first time yor are signing in, or because your password has expired</span>
                    </div>
                    <Form onSubmit={this.handleSubmit} noValidate>
                        {['oldPassword', 'newPassword', 'confirmPassword'].map((field) => (
                            <div className="p-1" key={field}>
                                <label className="form-label font-regular font12">
                                    {field === 'oldPassword' ? 'Old Password' : field === 'newPassword' ? 'New Password' : 'Confirm Password'}
                                </label>
                                <div className="input-group mb-1 upt-pass">
                                    <input
                                        className="form-control block mt-1 w-full font-regular font13"
                                        id={field}
                                        placeholder={`Enter ${field.replace(/([A-Z])/g, ' $1').trim()}`}
                                        type={this.state[`show${field.charAt(0).toUpperCase() + field.slice(1)}`] ? 'text' : 'password'}
                                        value={this.state[field]}
                                        onChange={this.handleChange}
                                        name={field}
                                        required
                                    />
                                    <span
                                        className="input-group-text togglePassword action-pointer"
                                        onClick={() => this.togglePasswordVisibility(`show${field.charAt(0).toUpperCase() + field.slice(1)}`)}
                                    >
                                        <i className={`fa-solid ${this.state[`show${field.charAt(0).toUpperCase() + field.slice(1)}`] ? 'fa-eye' : 'fa-eye-slash'} font12`}></i>
                                    </span>
                                </div>
                            </div>
                        ))}
                        <div className="d-grid gap-4 d-flex align-items-center m-3 justify-content-center">
                            <button className="btn btn-secondary font-semi-bold btn-primary font13" onClick={() => this.moveToLogin()}>Cancel</button>
                            <button className="btn btn-primary font-semi-bold btn-primary font13" type="submit" >Submit</button>
                        </div>

                        <div className="d-flex align-items-center flex-column mt-3">
                            <span className="font-bold font12 txt-primary action-pointer btn-action" onClick={() => this.moveToLogin()}>
                                <i className="fa-solid fa-arrow-left"></i> &nbsp; Back To Login</span>
                        </div>
                    </Form>
                </div>
            </div>
        </>
        )
    }
}



export default withNavigate(UpdatePassword);